<script>
	import { ActionsContainer, AdvancedCard, IconButton, LabelList } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	export let favorites = [
			{
				value: 80,
				labels: [{ value: `${this.value}%`, icon: 'fa-solid fa-blinds' }],
			},
		],
		loading = false;

	const dispatcher = createEventDispatcher();

	/*title={$format('command_set_position', {
				values: { n: favorite.pos }
			})}**/
</script>

{#key favorites.length}
	{#each favorites as favorite, i}
		<AdvancedCard
			class="mb-s"
			title={$format('label_position')}
			hideSlotTitle
			isFocusable={false}
			tabindex="-1"
		>
			<!--- THis is just idea -->
			<!-- <ActionsContainer orientation="vertical" type="simple" slot="left">
				<IconButton
					icon="fas fa-play"
					slot="first"
					variant="primary"
					{loading}
					on:click={() => dispatcher('set', favorite.pos)}
				/>
			</ActionsContainer> -->
			<LabelList size="m" labelList={favorite.labels} slot="main" />

			<ActionsContainer orientation="vertical" type="simple" slot="right">
				<IconButton
					icon="fas fa-pen"
					slot="first"
					variant="primary"
					disabled={loading}
					on:click={(e) => {
						e.stopPropagation();
						dispatcher('edit', { index: i });
					}}
					aria-label={$format('aria_edit_position', {
						default: 'Edit position',
					})}
				/>
				<IconButton
					class="align-self-center"
					icon="fas fa-trash"
					variant="danger"
					slot="second"
					disabled={loading}
					aria-label={$format('aria_delete_position', {
						default: 'Delete position',
					})}
					on:click={(e) => {
						e.stopPropagation();
						dispatcher('delete', { index: i });
					}}
				/>
			</ActionsContainer>
		</AdvancedCard>
	{/each}
{/key}
